export const pluralize = (string, shouldBePlural) => (shouldBePlural ? `${string}s` : string);
